import {useTranslation} from 'react-i18next';
import * as css from './DropPlaceholder.css';

function DropPlaceholder({expanded}: {expanded?: boolean}) {
    const {t} = useTranslation('global');
    return <css.placeholder expanded={expanded}>{t('drag')}</css.placeholder>;
}

export default DropPlaceholder;
